import {Component, EventEmitter, OnInit, Output, Input, OnChanges} from '@angular/core';
import {debounceTime, finalize} from 'rxjs/operators';
import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import {onlyNumbersValidator} from '../../custom-validators/only-numbers-validator';
import {FormErrorValidatorService} from '../../services/form-error-validator.service';
import {PhoneValidationFormVm} from '../../../../view-model/phone-validation-form/phone-validation-form.vm';
import { ActivatedRoute, Router } from '@angular/router';
import { SupportVm } from 'src/app/view-model/support/support.vm';
@Component({
  selector: 'app-validate-phone-form',
  templateUrl: './validate-phone-form.component.html',
  styleUrls: ['./validate-phone-form.component.scss'],
})
export class ValidatePhoneFormComponent implements OnInit, OnChanges {
  @Input() idPrefix = '';
  @Input() phone;
  @Input() isSignUpForm;
  @Input() isEditPhone: boolean = false;
  @Output() validated = new EventEmitter<any>();
  @Output() closeActivation = new EventEmitter<any>();
  smsValidationForm: FormGroup;
  reSendDisabled = true;
  isFirstReSend = true;
  isSecondReSend = false;
  isLoading = false;
  isTokenValid = false;
  showWhatsApp = false;
  smsToken = '';
  smsTokenAlgolia = '';
  error = {
    token: '',
  };
  errorObj: any;
  countDownCounter = 0;
  hideReSend;
  sendAlgolia = false;
  indexMessage;
  public showChangeMethodCode: boolean;
  public swZdWidget = false;
  public isFromStore: boolean = false;

  get maskedPhone() {
    if (!this.phone) { return ''; }

    const intialPhone = this.phone.substring(0, 4);
    const finalPhone = this.phone.substring(this.phone.length - 2);
    return `${intialPhone}****${finalPhone}`;
  }

  constructor(private formBuilder: FormBuilder,
              private fev: FormErrorValidatorService,
              private vm: PhoneValidationFormVm,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private supportVm: SupportVm) {
                this.showChangeMethodCode = false;
                this.activatedRoute.queryParams
                  .subscribe( params =>{
                    if(params && params?.store){
                      this.isFromStore = true;
                    }
                });
              }

  initSmsValidationForm() {
    this.smsValidationForm = this.formBuilder.group({
      token: new FormControl('', [onlyNumbersValidator, Validators.required]),
    });

    this.smsValidationForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe(values => {});
  }

  changeMethodOfCode(){
    this.showChangeMethodCode = true;
  }

  getSmsToken() {
    const isRegister = !this.isEditPhone;
    this.isLoading = true;
    this.vm.validateSmsToken(this.phone, null, null, isRegister)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.countDown();
      }))
      .subscribe(response => {
        if (response.code ===  'OK') {
          this.smsToken = response.tokenFarmatodo;
          this.reSendTimer();
          this.isFirstReSend = false;
        }
        this.errorObj = response;
      });
  }

  getSmsAlgoliaToken(ftdToken?, sendAlgolia?) {
    this.vm.validateSmsTokenFinal()
      .pipe(finalize(() => {
        if (this.isSignUpForm) {
          this.smsTokenAlgolia = ftdToken || '8930';
        } else {
          this.smsToken = ftdToken || '8930';
        }
        if (!this.isSignUpForm) {
          this.hideReSend = true;
        } else if (sendAlgolia) {
          this.isSecondReSend = true;
          this.countDown();
        }
      }))
      .subscribe(token => {
        ftdToken = token;
      });
  }

  countDown() {
    this.countDownCounter =  this.vm.getConfigurationModules('sms-lasting-time');
    const interval = setInterval(() => {
      this.countDownCounter -= 1;

      if (this.countDownCounter <= 0) {
        clearInterval(interval);
        this.countDownCounter = -1;
      }
    }, 1000);
  }

  reSendTimer() {
    const delay = 20000;
    this.reSendDisabled = true;
    setTimeout(() => {
      this.reSendDisabled = false;
    }, delay);
  }

  reSend() {
    this.errorObj = null;
    if (this.isSignUpForm && this.isSecondReSend) {
      this.showWhatsApp = true;
    }
    this.getSmsToken();
  }

  validate() {
    
    if (this.smsValidationForm.valid && this.smsValidationForm.controls.token.value){
      this.vm.validateCodeToken( this.phone, this.smsValidationForm.controls.token.value ).subscribe( response =>{
        if(response.code ===  'OK'){
          this.validated.emit(true);
          this.goToHome();
          if(this.isFromStore){
            this.closeActivation.emit(true);
          }
        }else{
          this.error.token = 'Tu código no es válido';
        }
      },
      error => {
        this.error.token = error.message;
      });
    } 
  }

  goToHome(){
    if( window.location.pathname !== '/cuenta/perfil') {
      this.router.navigate(['/']);
    }
  }

  getTokens() {
    if (this.phone) {
      this.getSmsToken();
    } else {
      this.errorObj = {message: 'No tiene un teléfono válido'};
    }
  }

  ngOnInit() {
      this.initSmsValidationForm();
      this.getTokens();
  }

  openZdWidget() {
    this.supportVm.openChat();
  }

  closeSelect( event ){
    if(event.close){
      this.error.token = '';
      this.clearToken();
      this.showChangeMethodCode = false;
    }
  }

  ngOnChanges() {
    if (!this.isSignUpForm) {
      this.initSmsValidationForm();
      this.getTokens();
    }
  }

  changeNewCode( {code} ){
    if (this.isSignUpForm) {
      this.smsTokenAlgolia = code;
    }
  }

  clearToken(){
    this.smsValidationForm.controls.token.setValue('');
  }
}